<template>
  <div class="pb-5">
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
              ><i class="fa fa-arrow-left text-dark"></i
            ></v-btn>
            تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="customerDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <h4>ویرایش مشتری</h4>
          </v-card-title>
          <v-card-text class="py-0 px-2">
            <v-container class="mt-3">
              <v-text-field
                outlined
                dense
                label="نام مشتری"
                :loading="progress"
                v-model="customerName"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                dir="ltr"
                label="نام انگلیسی مشتری"
                :loading="progress"
                v-model="customerNameEn"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                dir="ltr"
                label="شماره اقتصادی"
                :loading="progress"
                v-model="economicalNumber"
                type="number"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                dir="ltr"
                label="شماره ثبت/ شماره ملی"
                :loading="progress"
                v-model="nationalNumber"
                type="number"
              ></v-text-field>
              <v-select
                label="رتبه مشتری"
                :items="customerPriorities"
                v-model="customerPriority"
                :loading="progress"
                :disabled="role != 'Manager' && role != 'salesManager'"
                outlined
                dense
              />
              <v-text-field
                outlined
                dense
                label="موبایل سازمانی (جهت دریافت پیامک‌های سیستمی)"
                :loading="progress"
                v-model="customerMobile"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                label="ایمیل سازمانی (جهت دریافت ایمیل‌های سیستمی)"
                :loading="progress"
                v-model="customerEmail"
              ></v-text-field>
              <v-autocomplete
                v-model.trim="stateId"
                :items="states"
                label=" استان"
                outlined
                dense
                item-text="name"
                item-value="id"
                no-data-text="موردی یافت نشد."
                hide-details
                :loading="stateLoading"
                class="mb-4"
              >
              </v-autocomplete>
              <v-autocomplete
                v-model.trim="cityId"
                :items="cities"
                label="شهر"
                outlined
                dense
                item-text="name"
                item-value="id"
                no-data-text="موردی یافت نشد."
                hide-details
                :loading="cityLoading"
                class="mb-4"
              >
              </v-autocomplete>
              <v-text-field
                v-model="address"
                outlined
                dense
                label="آدرس"
              ></v-text-field>
              <v-text-field
                v-model="phone"
                outlined
                dense
                label="تلفن یا نمابر"
                type="number"
              ></v-text-field>
            </v-container>
          </v-card-text>
          <v-card-actions class="p-3 mr-3">
            <v-spacer></v-spacer>
            <v-btn
              class="text-white"
              color="red"
              @click="
                customerDialog = false;
                economicalNumber = '';
                nationalNumber = '';
                address = '';
                cityId = '';
                stateId = '';
                postalCode = '';
                phone = '';
              "
            >
              لغو
            </v-btn>
            <v-btn color="primary" @click="editCustomer()"> ثبت </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    <v-card>
      <v-card-title>
        <h4>
          <a
            :href="'/factory/order/' + myOrderId"
            class="btn btn-dark"
            target="_blank"
            rel="noopener noreferrer"
            >مشاهده پرونده سفارش
          </a>
        </h4>
      </v-card-title>
      <v-card-text class="py-0 px-2" v-if="remainOrder && remainOrder.length">
        <!-- <p>
            لطفا به منظور صدور فاکتور جدید، حداکثر 12 عدد از اقلام باقی مانده در
            سفارش را انتخاب کنید و به جدول فاکتور اضافه بفرمایید. همچنین شما
            میتوانید یک قلم کالای دلخواه نیز به هر فاکتور اضافه کنید. سپس دکمه
            مشاهده نهایی را بزنید و نسخه نهایی تولید شده را مشاهده کنید.
          </p> -->
        <v-row class="mt-4">
          <v-col cols="5">
            <div class="d-flex">
              <span class="me-2 mt-2">شماره فاکتور:</span>
              <span>
                <v-text-field
                  outlined
                  dense
                  label="شماره فاکتور"
                  v-model="invoice.invoiceCode"
                ></v-text-field
              ></span>
            </div>
          </v-col>
        </v-row>
        <!--seller-->
        <v-card class="mt-1">
          <v-card-title class="white black--text d-flex justify-center"
            >مشخصات فروشنده</v-card-title
          >
          <hr />
          <v-card-text>
            <v-row class="text-center">
              <v-col cols="6" class="d-flex">
                <img
                  src="../../assets/images/big.png"
                  alt=""
                  v-show="invoice.isLogoShow"
                  style="width: 40%; height: 40px !important"
                />
                <div class="ms-10">
                  <v-btn
                    v-if="invoice.isLogoShow"
                    class="warning"
                    @click="invoice.isLogoShow = false"
                    >نشان ندادن عکس</v-btn
                  >
                  <v-btn
                    v-else
                    class="primary"
                    @click="invoice.isLogoShow = true"
                    >نشان دادن عکس</v-btn
                  >
                </div>
              </v-col>
              <v-col cols="2"></v-col>
              <v-col cols="4" class="d-flex">
                <v-text-field
                  outlined
                  dense
                  height="40"
                  v-model="invoice.registerDate"
                  id="followingDate"
                >
                  <template slot="label">
                    <div style="font-size: 14px">تاریخ</div>
                  </template>
                </v-text-field>

                <v-btn
                  class="ms-2 blue-borderedBtn"
                  id="followingDate"
                  width="40"
                  min-width="40"
                  height="40"
                  ><v-icon>$Calendar</v-icon></v-btn
                >
                <date-picker
                  element="followingDate"
                  v-model="invoice.registerDate"
                  :label="currentDate"
                  color="#6092cd"
                >
                </date-picker>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="4" class="text-center">
                <div>
                  <v-text-field
                    outlined
                    dense
                    dir="ltr"
                    label="شماره اقتصادی"
                    v-model="invoice.economicalNo"
                    type="number"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  outlined
                  dense
                  dir="ltr"
                  label="شماره ثبت/ شماره ملی"
                  v-model="invoice.nationalId"
                  type="number"
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                <div>
                  <v-text-field
                    v-model="invoice.postalCode"
                    outlined
                    dense
                    label="کد پستی"
                    type="number"
                    style="direction: ltr"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="8">
                <v-text-field
                  v-model="invoice.address"
                  outlined
                  dense
                  label="آدرس"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="invoice.tel"
                  outlined
                  dense
                  label="تلفن یا نمابر"
                  style="direction: ltr"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!--customer-->
        <v-card class="mt-5">
          <v-card-title class="white black--text d-flex justify-center"
            >مشخصات خریدار</v-card-title
          >
          <hr />
          <v-card-text>
            <v-row class="text-center">
              <v-col cols="4">
                <span>
                  <v-text-field
                    outlined
                    dense
                    label="نام شخص حقیقی/ حقوقی"
                    v-model="invoice.customerName"
                  ></v-text-field
                ></span>
              </v-col>
              <v-col cols="4" class="text-center">
                <span>
                  <v-text-field
                    outlined
                    dense
                    dir="ltr"
                    label="شماره اقتصادی"
                    v-model="invoice.customerEconomicalCode"
                    type="number"
                  ></v-text-field>
                </span>
              </v-col>
              <v-col>
                <span>
                  <v-text-field
                    outlined
                    dense
                    dir="ltr"
                    label="شماره ثبت/ شماره ملی"
                    v-model="invoice.customerNationalId"
                    type="number"
                  ></v-text-field>
                </span>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="4">
                <span class="me-2">
                  <span>
                    <v-autocomplete
                      v-model.trim="invoice.stateId"
                      :items="states"
                      label=" استان"
                      outlined
                      dense
                      item-text="name"
                      item-value="id"
                      no-data-text="موردی یافت نشد."
                      hide-details
                      :loading="stateLoading"
                      class="mb-4"
                      @input="getCities()"
                    >
                    </v-autocomplete> </span
                ></span>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  outlined
                  dense
                  label="شهرستان"
                  :loading="progress"
                  v-model="invoice.province"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <span>
                  <span>
                    <v-autocomplete
                      v-model.trim="invoice.cityId"
                      :items="cities"
                      label="شهر"
                      outlined
                      dense
                      item-text="name"
                      item-value="id"
                      no-data-text="موردی یافت نشد."
                      hide-details
                      :loading="cityLoading"
                      class="mb-4"
                    >
                    </v-autocomplete> </span
                ></span>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="4">
                <span>
                  <v-text-field
                    v-model="invoice.customerPostalCode"
                    outlined
                    dense
                    label="کد پستی"
                    type="number"
                  ></v-text-field>
                </span>
              </v-col>
              <v-col cols="4">
                  <v-text-field
                    v-model="invoice.CustomerAddress"
                    outlined
                    dense
                    label="آدرس"
                  ></v-text-field>
                </v-col>
              <v-col cols="4">
                <span dir="ltr" class="ms-2">
                  <v-text-field
                    v-model="invoice.CustomerTel"
                    outlined
                    dense
                    label="تلفن یا نمابر"
                    type="number"
                  ></v-text-field>
                </span>
              </v-col>
            </v-row>
            <!-- <v-row class="mt-6">
                <v-col cols="12" class="d-flex justify-end me-4">
                  <v-btn class="warning" v-show="false" @click="editCustomerDialog()"
                    >ویرایش</v-btn
                  >
                </v-col>
              </v-row> -->
          </v-card-text>
        </v-card>

        <!-- <b-row class="mt-5">
            <b-col cols="2"
              ><b-button
                @click="invoiceListCalculate(0)"
                variant="warning"
                class="m-2"
                >خالی کردن فاکتور</b-button
              ></b-col
            >
            <b-col cols="2"
              ><b-button
                @click="invoiceListCalculate(100)"
                variant="warning"
                class="m-2"
                >افزودن کل کالاهای باقیمانده</b-button
              ></b-col
            >
            <b-col cols="2"></b-col>
            <b-col cols="2"></b-col>
            <b-col cols="2"
              ><b-form-input
                v-model="desiredPercentage"
                type="number"
                class="m-2"
                placeholder="درصد ارسال مورد نظر"
              ></b-form-input
            ></b-col>
            <b-col cols="2">
              <b-button
                @click="invoiceListCalculate(desiredPercentage)"
                variant="warning"
                class="m-2"
                :disabled="!desiredPercentage"
                >ارسال درصد مشخص شده</b-button
              ></b-col
            >
          </b-row> -->
        <v-row class="mt-10 ms-2">
          <p class="red--text">
            فقط امکان اضافه کردن 12 آیتم را دارید (
            {{ invoiceEditableItems.length }} مورد انتخاب شده است).
          </p>
        </v-row>
        <b-table
          :busy="tableBusy"
          ref="orderItemsTable"
          responsive
          show-empty
          :items="remainOrder"
          :fields="originalOrderOperationFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary mt-10"
          style="font-family: Tahoma !important"
          small
        >
          <template v-slot:head()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <v-btn
                class="success white--text"
                @click="addToInvoice(data.item, data.index)"
                >اضافه کردن</v-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>

          <template v-slot:cell(unitCost)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.unitCost"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(totalPrice)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ (data.item.perPrice * data.item.number).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(discountCost)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ (data.item.perPrice * discountPercent).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(afterDiscount)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  data.item.perPrice * data.item.number -
                  data.item.perPrice *
                    data.item.number *
                    (discountPercent / 100)
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(vat)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100)) *
                  orderVat
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(total)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100)) *
                    orderVat +
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100))
                ).toLocaleString()
              }}
            </div>
          </template>
          <!-- <template v-slot:cell(discountPercent)="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ (data.item.totalPrice - data.item.discountPercent).toLocaleString() }}
              </div>
            </template> -->
          <template v-slot:cell(number)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.number"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <!-- <template #custom-foot="data">
            <b-tr>
              <b-th colspan="6">جمع کل</b-th>
              <b-th colspan="2">{{ computedTotalPrice.toLocaleString() }}</b-th>
              <b-th class="text-center">{{
                computedTotalAfterDiscount.toLocaleString()
              }}</b-th>
              <b-th class="text-center">{{
                computedTotalVat.toLocaleString()
              }}</b-th>
              <b-th class="text-center">{{
                computedTotal.toLocaleString()
              }}</b-th>
            </b-tr>
          </template> -->
        </b-table>

        <hr />

        <v-row class="ms-2 mt-5 d-flex justify-content-between">
          <p class="green--text font-weight-bold">آیتمهای انتخاب شده:</p>
          <div>
            <v-btn class="primary me-4" @click="addingRow()">افزودن سطر</v-btn>
          </div>
        </v-row>
        <b-table
          :busy="tableBusy"
          ref="orderItemsTable"
          responsive
          show-empty
          :items="invoiceEditableItems"
          :fields="originalOrderOperationEditFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary mt-4"
          style="font-family: Tahoma !important"
          small
        >
          <template v-slot:head()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.index + 1"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <v-btn
                class="red white--text"
                @click="deleteInvoiceItem(data.item)"
                >حذف</v-btn
              >
            </div>
          </template>

          <template v-slot:cell(customerIndex)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.customerIndex"
                type="text"
              ></b-form-input>
            </div>
          </template>

          <template v-slot:cell(description)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.description"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(measurementUnit)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.measurementUnit"
                type="text"
              ></b-form-input>
            </div>
          </template>

          <template v-slot:cell(perPrice)="data">
            <div style="text-align: center; vertical-align: middle">
              <vuetify-money
                v-model="data.item.perPrice"
                :valueWhenIsEmpty="valueWhenIsEmpty"
                :options="perPriceOptions"
                type="number"
                outlined
                dense
              />
            </div>
          </template>
          <template v-slot:cell(totalPrice)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ (data.item.perPrice * data.item.number).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(discountCost)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  data.item.perPrice * discountPercent
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(afterDiscount)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  data.item.perPrice * data.item.number -
                  data.item.perPrice *
                    data.item.number *
                    (discountPercent / 100)
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(vat)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100)) *
                  orderVat
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(total)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100)) *
                    orderVat +
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100))
                ).toLocaleString()
              }}
            </div>
          </template>
          <!-- <template v-slot:cell(discountPrice)="data">
    <div
      dir="ltr"
      style="
        text-align: center;
        vertical-align: middle;
        font-family: Tahoma;
      "
    >
      {{ (data.item.totalPrice - data.item.discountPrice).toLocaleString() }}
    </div>
  </template> -->
          <template v-slot:cell(number)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.number"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template #custom-foot="data">
            <b-tr>
              <b-th colspan="7">جمع کل</b-th>
              <b-th colspan="2">{{ computedTotalPrice.toLocaleString() }}</b-th>
              <b-th class="text-center">{{
                computedTotalAfterDiscount.toLocaleString()
              }}</b-th>
              <b-th class="text-center">{{
                computedTotalVat.toLocaleString()
              }}</b-th>
              <b-th class="text-center">{{
                computedTotal.toLocaleString()
              }}</b-th>
            </b-tr>
          </template>
        </b-table>

        <v-row>
          <v-col cols="6" class="d-flex my-5">
            <span class="mt-2 me-4">شرایط و نحوه پرداخت: </span>
            <v-select
              label="شرایط و نحوه پرداخت"
              :items="payOptions"
              v-model="invoice.cash"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <p>توضیحات فاکتور</p>
        <div class="mb-5 item-ckeditor ">
          <ckeditor
            v-model="invoice.description"
           :editor="editor"
                  :config="editorConfig"
            @blur="onBlur($event)"
            @focus="onFocus($event)"
            @contentDom="onContentDom($event)"
            @dialogDefinition="onDialogDefinition($event)"
            @fileUploadRequest="onFileUploadRequest($event)"
            @fileUploadResponse="onFileUploadResponse($event)"
          />
        </div>

        <b-button @click="saveInvoiceList()" variant="primary" class="my-2"
          >مشاهده نهایی فاکتور جدید</b-button
        >

        <b-table
          v-if="showResultTable"
          responsive
          show-empty
          :items="finalInvoiceItems"
          :fields="originalOrderFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table"
          style="font-family: Tahoma !important"
          small
        >
          <template v-slot:head()="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:cell(totalPrice)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ (data.item.perPrice * data.item.number).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(discountCost)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{ (data.item.perPrice * discountPercent).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(afterDiscount)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  data.item.perPrice * data.item.number -
                  data.item.perPrice *
                    data.item.number *
                    (discountPercent / 100)
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(vat)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100)) *
                  orderVat
                ).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(total)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma;
              "
            >
              {{
                (
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100)) *
                    orderVat +
                  (data.item.perPrice * data.item.number -
                    data.item.perPrice *
                      data.item.number *
                      (discountPercent / 100))
                ).toLocaleString()
              }}
            </div>
          </template>
          <template #custom-foot="data">
            <b-tr>
              <b-th colspan="6">جمع کل</b-th>
              <b-th colspan="2">{{ computedTotalPrice.toLocaleString() }}</b-th>
              <b-th class="text-center">{{
                computedTotalAfterDiscount.toLocaleString()
              }}</b-th>
              <b-th class="text-center">{{
                computedTotalVat.toLocaleString()
              }}</b-th>
              <b-th class="text-center">{{
                computedTotal.toLocaleString()
              }}</b-th>
            </b-tr>
          </template>
        </b-table>
      </v-card-text>
      <v-card-text class="py-0 px-2" v-else>
        <h3>امکان تعریف فاکتور جدید وجود ندارد.</h3>
      </v-card-text>
      <v-card-actions class="p-3 mr-3">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!showResultTable || !finalInvoiceItems.length"
          @click="submitNewInvoice()"
        >
          ثبت ویرایش
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      invoiceCode: "",
      role: "",
      customerPriorities: [
        { value: "VIP", text: "VIP" },
        { value: "معمولی", text: "معمولی" },
        { value: "لیست سیاه", text: "لیست سیاه" },
      ],
      invoice: {
        customerName: "",
        customerNameEn: "",
        customerPriority: "",
        customerMobile: "",
        customerEmail: "",
        stateId: "",
        cityId: "",
        address: "",
        economicalNumber: "",
        nationalNumber: "",
        postalCode: "",
        phone: "",
        pay: "",
        description: "",
        items: [],
      },
      progress: false,
      states: [],
      cities: [],
      stateLoading: false,
      cityLoading: false,
      payOptions: [
        { value: true, text: "نقدی" },
        { value: false, text: "غیر نقدی" },
      ],
      guide: false,
      isBusy: false,
      showResultTable: false,
      valueWhenIsEmpty: "",
      options: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        length: 16,
      },
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      finalInvoiceItems: [],
      tableBusy: true,
      originalOrderFields: [
        { key: "index", label: "ردیف" },
        { key: "customerIndex", label: "کد کالا" },
        { key: "description", label: "شرح کالا یا خدمات" },
        { key: "number", label: "تعداد/مقدار" },
        { key: "measurementUnit", label: "واحد اندازه گیری" },
        { key: "perPrice", label: "مبلغ واحد" },
        { key: "totalPrice", label: "مبلغ کل" },
        { key: "discountCost", label: "مبلغ تخفیف" },
        { key: "afterDiscount", label: "مبلغ کل پس از تخفیف (ریال)" },
        { key: "vat", label: "جمع مالیات و عوارض (ریال)" },
        { key: "total", label: "مبلغ نهایی (ریال)" },
      ],
      originalOrderOperationFields: [
        { key: "index", label: "ردیف" },
        { key: "operation", label: "اضافه کردن به فاکتور" },
        { key: "customerIndex", label: "کد کالا" },
        { key: "description", label: "شرح کالا یا خدمات" },
        { key: "number", label: "تعداد/مقدار" },
        { key: "measurementUnit", label: "واحد اندازه گیری" },
        { key: "perPrice", label: "مبلغ واحد" },
        { key: "totalPrice", label: "مبلغ کل" },
        { key: "discountCost", label: "مبلغ تخفیف" },
        { key: "afterDiscount", label: "مبلغ کل پس از تخفیف (ریال)" },
        { key: "vat", label: "جمع مالیات و عوارض (ریال)" },
        { key: "total", label: "مبلغ نهایی (ریال)" },
      ],
      originalOrderOperationEditFields: [
        { key: "operation", label: "حذف" },
        { key: "index", label: "ردیف" },
        { key: "customerIndex", label: "کد کالا" },
        { key: "description", label: "شرح کالا یا خدمات" },
        { key: "number", label: "تعداد/مقدار" },
        { key: "measurementUnit", label: "واحد اندازه گیری" },
        { key: "perPrice", label: "مبلغ واحد" },
        { key: "totalPrice", label: "مبلغ کل" },
        { key: "discountCost", label: "مبلغ تخفیف" },
        { key: "afterDiscount", label: "مبلغ کل پس از تخفیف (ریال)" },
        { key: "vat", label: "جمع مالیات و عوارض (ریال)" },
        { key: "total", label: "مبلغ نهایی (ریال)" },
      ],
      priorityOptions: [
        {
          value: "low",
          text: "پایین",
        },
        {
          value: "normal",
          text: "معمولی",
        },
        {
          value: "high",
          text: "بالا",
        },
        {
          value: "urgent",
          text: "اورژانسی",
        },
      ],
      myOrderId: "",
      desiredPercentage: "",
      customerDialog: false,
      invoice: {
        economicalNumber: "411333598578",
        nationalNumber: "10102143437",
        postalCode: "3393164519",
        address:
        "جاده خراسان - شهرک صنعتی عباس‌آباد، خیابان دلگشا، خیابان جامی، کوچه 1/2، پلاک844",
        phone: "(021)36425404-5",
      },
      invoiceEditableItems: [],
      registerDate: "",
      currentDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      invoice: [],
      remainOrder: [],
      orderVat: 0.09,
      discountPercent: 0,
    };
  },
  computed: {
    perPriceOptions() {
      let myOptions = {
        decimal: ".",
        thousands: ",",
        precision: 0,
      };
      try {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: 0,
        };
      } catch (error) {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: 0,
        };
      }
      return myOptions;
    },
    computedTotalPrice() {
      if (this.invoiceEditableItems && this.invoiceEditableItems.length) {
        return this.invoiceEditableItems
          .map((item) => item.perPrice * item.number)
          .reduce((a, b) => {
            return a + b;
          });
        
      }else {
        return 0
      }
    },
    computedTotalAfterDiscount() {
      if (this.invoiceEditableItems && this.invoiceEditableItems.length) {
        
        return this.invoiceEditableItems
          .map(
            (item) =>
              item.perPrice * item.number -
              item.perPrice * item.number * (this.discountPercent / 100)
          )
          .reduce((a, b) => {
            return a + b;
          });
      }else {
        return 0
      }
    },
    computedTotalVat() {
      if (this.invoiceEditableItems && this.invoiceEditableItems.length) {
        
        return this.invoiceEditableItems
          .map(
            (item) =>
              (item.perPrice * item.number -
                item.perPrice * item.number * (this.discountPercent / 100)) *
              this.orderVat
          )
          .reduce((a, b) => {
            return a + b;
          });
      }else {
        return 0
      }
    },
    computedTotal() {
      if (this.invoiceEditableItems && this.invoiceEditableItems.length) {
        
        return this.invoiceEditableItems
          .map(
            (item) =>
              (item.perPrice * item.number -
                item.perPrice * item.number * (this.discountPercent / 100)) *
                this.orderVat +
              (item.perPrice * item.number -
                item.perPrice * item.number * (this.discountPercent / 100))
          )
          .reduce((a, b) => {
            return a + b;
          });
      }else {
        return 0
      }
    },
  },
  methods: {
    addingRow() {
      this.invoiceEditableItems.push({
        index: this.invoiceEditableItems.length
          ? this.invoiceEditableItems.length + 1
          : 1,
        customerIndex: "",
        description: "",
        number: "",
        measurementUnit: "",
        perPrice: "",
      });
    },
    deleteInvoiceItem(item) {
      this.invoiceEditableItems = this.invoiceEditableItems.filter(
        (data) => data.index != item.index
      );
    },
    addToInvoice(item, index) {
      console.log(item.index);
      let newItems = this.invoiceEditableItems;
      if (newItems.length < 12) {
        if (newItems.filter((data) => data.index == item.index)[0]) {
          this.toast("این محصول قبلا به فاکتور اضافه شده است", "error");
        } else {
          this.invoiceEditableItems.push(item);
        }
      } else {
        this.toast("بیش‌تر از 12 آیتم نمیتوانید به فاکتور اضافه کنید", "error");
      }
    },
    editCustomerDialog() {
      this.customerDialog = true;
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    invoiceListEmpty() {
      this.tableBusy = true;
      this.invoice.items.forEach((element) => {
        element.qty = 0;
      });
      setTimeout(() => {
        this.tableBusy = false;
      }, 500);
    },
    invoiceListFull() {
      this.tableBusy = true;
      this.invoice.items.forEach((element) => {
        element.qty = Number(element.number) - Number(element.previousQTY);
      });
      setTimeout(() => {
        this.tableBusy = false;
      }, 500);
    },
    invoiceListCalculate(percentage) {
      if (percentage > 100)
        this.toast(
          "درصد انتخابی بیشتر از 100 است. لطفا عددی بین 0 تا 100 انتخاب کنید.",
          "error"
        );
      else if (percentage < 0)
        this.toast(
          "درصد انتخابی منفی است. لطفا عددی بین 0 تا 100 انتخاب کنید.",
          "error"
        );
      else {
        this.tableBusy = true;
        this.invoice.items.forEach((element) => {
          element.qty = parseInt(
            ((Number(element.number) - Number(element.previousQTY)) *
              percentage) /
              100
          );
        });
        setTimeout(() => {
          this.tableBusy = false;
        }, 500);
      }
    },
    getState() {
      this.stateLoading = true;
      Axios.get(this.baseUrl + "/ppkpms/requirements/allStates", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.stateLoading = false;
            this.states = res.data;
          }
        })
        .catch((err) => {
          this.stateLoading = false;
          console.log(err);
        });
    },
    getCities() {
      this.cityLoading = true;
      if (this.invoice.stateId) {
        Axios.get(
          this.baseUrl +
            "/ppkpms/requirements/citiesOfState/" +
            this.invoice.stateId,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.cityLoading = false;
              this.cities = res.data;
              this.reactivity = !this.reactivity;
            }
          })
          .catch((err) => {
            this.cityLoading = false;
            console.log(err);
          });
      }
    },
    saveInvoiceList() {
      this.showResultTable = false;
      this.finalInvoiceItems = this.invoiceEditableItems.filter((x) => Number(x.number));
      this.finalInvoiceItems.forEach((item) => {
        item.price = item.perPrice * item.number;
        item.discount = item.perPrice * this.discountPercent;
        item.discountPrice =
          item.perPrice * item.number -
          item.perPrice * item.number * (this.discountPercent / 100);
        item.tax =
          (item.perPrice * item.number -
            item.perPrice * item.number * (this.discountPercent / 100)) *
          this.orderVat;
        item.payPrice =
          (item.perPrice * item.number -
            item.perPrice * item.number * (this.discountPercent / 100)) *
            this.orderVat +
          (item.perPrice * item.number -
            item.perPrice * item.number * (this.discountPercent / 100));
        item.code = item.customerIndex;
      });
      setTimeout(() => {
        this.showResultTable = true;
      }, 500);
    },

    submitNewInvoice() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/accounting/invoice/edit",
        {
          invoiceId: this.$route.params.id,
          invoiceCode: this.invoice.invoiceCode,
          customerNationalId: this.invoice.customerNationalId,
          customerEconomicalCode: this.invoice.customerEconomicalCode,
          customerName: this.invoice.customerName,
          CustomerAddress: this.invoice.CustomerAddress,
          CustomerTel: this.invoice.CustomerTel,
          customerPostalCode: this.invoice.customerPostalCode,
          stateId: this.invoice.stateId,
          province: this.invoice.province,
          cityId: this.invoice.cityId,
          customerNationalId: this.invoice.customerNationalId,
          description: this.invoice.description,
          registerDate: this.invoice.registerDate,
          list: this.finalInvoiceItems,
          // status: "submitted",
          totalPrice: this.computedTotalPrice,
          totalDiscount: this.discountPercent,
          totoalDiscountPrice: this.computedTotalAfterDiscount,
          totoalTax: this.computedTotalVat,
          totalPayPrice: this.computedTotal,
          // rFootText: "متن سمت راست",
          // lFootText: "متن سمت چپ",
          cash: this.invoice.cash,
          // official: true,
          name: "پولاد پیچ‌کار",
          economicalNo: this.invoice.economicalNo,
          nationalId: this.invoice.nationalId,
          postalCode: this.invoice.postalCode,
          address: this.invoice.address,
          tel: this.invoice.tel,
          isLogoShow: this.invoice.isLogoShow,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.vLoading = false;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.vLoading = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showInvoice() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/accounting/invoice/getInfo",
        {
          invoiceId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.invoice = res.data.invoice;
            this.invoiceEditableItems = this.invoice.list;
            if (this.invoice.stateId) {
              this.getCities();
            }
            this.invoice.list.forEach((item) => {
              item.customerIndex = item.code;
            });
            this.remainOrder = res.data.remainInvoices;
            this.remainOrder.forEach((item) => {
              item.number = 0;
            });
            this.orderVat = res.data.orderVat;
            this.discountPercent = res.data.discountPercent;
            this.tableBusy = false;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.myOrderId = this.$route.params.id;
    this.showInvoice();
    this.getState();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
